import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import User from '@engine/user'
import { Loading } from '@components/common'

export const eventListener = props => (event, error) => {
  const { keycloak, getUser, getJob } = props

  if (error) {
    console.error('error in AuthProvider event listener', { error })

    return error
  }

  switch (event) {
    case 'onReady':
      if (!keycloak.authenticated) {
        keycloak.login()
      }
      getUser()
      getJob()
      break
    case 'onTokenExpired':
      keycloak.updateToken()
      break
    case 'onAuthError':
    // eslint-disable-no-fallthrough
    case 'onAuthRefreshError':
    // eslint-disable-no-fallthrough
    case 'onAuthLogout':
    // eslint-disable-no-fallthrough
    case 'onInitError':
      keycloak.clearToken()
      break
    // do-nothing events (let the token listener grab the token, and validate)
    case 'onAuthSuccess':
      break
    case 'onAuthRefreshSuccess':
      break
    default:
      break
  }

  return event
}

const AuthProvider = ({ keycloak, children, entityUserGuid, getUser, getJob }) => (
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{ onLoad: 'login-required', promiseType: 'native', checkLoginIframe: false }}
    LoadingComponent={<Loading isLoading={true} text={'Loading...'} />}
    onEvent={eventListener({ keycloak, getUser, getJob })}
  >
    {entityUserGuid && children}
  </ReactKeycloakProvider>
)

AuthProvider.propTypes = {
  children: PropTypes.any,
  keycloak: PropTypes.object,
  getUser: PropTypes.func,
  getJob: PropTypes.func,
  entityUserGuid: PropTypes.string
}

const mapDispatchToProps = {
  getUser: User.actions.get,
  getJob: User.actions.getUserJobTitle
}

const mapStateToProps = state => ({
  entityUserGuid: User.selectors.user.entityUserGuid(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(AuthProvider)
